// Shared color constants and utilities for consistent color handling across the app

export interface ColorOption {
  value: string;
  label: string;
  hex: string;
}

export const COLOR_OPTIONS: ColorOption[] = [
  { value: 'gray', label: 'Gray', hex: '#6B7280' },
  { value: 'red', label: 'Red', hex: '#EF4444' },
  { value: 'orange', label: 'Orange', hex: '#F97316' },
  { value: 'yellow', label: 'Yellow', hex: '#EAB308' },
  { value: 'lime', label: 'Lime', hex: '#84CC16' },
  { value: 'green', label: 'Green', hex: '#22C55E' },
  { value: 'teal', label: 'Teal', hex: '#14B8A6' },
  { value: 'cyan', label: 'Cyan', hex: '#06B6D4' },
  { value: 'sky', label: 'Sky', hex: '#0EA5E9' },
  { value: 'blue', label: 'Blue', hex: '#3B82F6' },
  { value: 'indigo', label: 'Indigo', hex: '#6366F1' },
  { value: 'purple', label: 'Purple', hex: '#A855F7' },
  { value: 'violet', label: 'Violet', hex: '#8B5CF6' },
  { value: 'pink', label: 'Pink', hex: '#EC4899' },
  { value: 'rose', label: 'Rose', hex: '#F43F5E' },
  { value: 'stone', label: 'Stone', hex: '#78716C' },
];

/**
 * Get hex color value for a color name
 * @param colorName - The color name (e.g., 'blue', 'red')
 * @returns The hex color value (e.g., '#3B82F6')
 */
export const getColorHex = (colorName: string): string => {
  const colorOption = COLOR_OPTIONS.find(option => option.value === colorName);
  return colorOption?.hex || COLOR_OPTIONS[0].hex; // Default to gray if not found
};

/**
 * Get color label for a color name
 * @param colorName - The color name (e.g., 'blue', 'red')
 * @returns The formatted color label (e.g., 'Blue', 'Red')
 */
export const getColorLabel = (colorName: string): string => {
  const colorOption = COLOR_OPTIONS.find(option => option.value === colorName);
  return colorOption?.label || colorName.charAt(0).toUpperCase() + colorName.slice(1);
};